import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import LiveTooltip from 'live/components/ui/tooltip'

import { Sanitizer } from 'live/services/sanitizer'

import { HeaderItem } from 'plugin-smart-mobility-utils/shared/HeaderItem/HeaderItem'
import { Separator } from 'plugin-smart-mobility-utils/shared/Separator/Separator'

import RowToWidget from 'plugin-smart-mobility-utils/shared/ui/Widget/RowToWidget/RowToWidget'
import SingleDropdown from "plugin-smart-mobility-utils/shared/SingleDropdown"
import Dropdown from "plugin-smart-mobility-utils/shared/Dropdown/Dropdown"
import AvailabilityGraphDaily from 'plugin-smart-mobility-utils/shared/ui/Widget/AvailabilityGraphDaily/AvailabilityGraphDaily'
import DynamicTable from 'plugin-smart-mobility-utils/shared/ui/Widget/DynamicTable/DynamicTable'
import {Satcom, Celular1, Celular2} from "../../utils/svg";

import GlobalStyle from "../../utils/createGlobalStyle"

import Subscriber from 'live/services/subscription'
import i18n from "live/services/i18n";
import {KpiInformation, PropsInformation} from "./components/KpiInformation";

enum STATUS {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}

enum OBC {
    ONLINE = 'Online',
    OFFLINE = 'Offline',
}
type Uplink = {
    icon: string;
    color: string;
    background: string;
};

type Availability = {
    title: string;
    subtitle: string;
    color: string;
};

type StackStatus = {
    status: STATUS;
    color: string;
};

type ObcStatus = {
    status: OBC;
    color: string;
};

type EventTable = {
    vehicle_ID: string;
    stack: StackStatus;
    obc: ObcStatus;
    last_disconnection: string;
    uplinks: Uplink[];
    last_Event: string;
    hour_first_event: string;
    availability: Availability[];
};

type Event = {
    title: {name: string, icon: string},
    stacks: number,
    stacksActive: {
        total: number,
        percentage: number
    },
    stacksInactive: {
        total: number,
        percentage: number
    },
    onboardConnectivity: {
        online: {
            total: number,
            percentage: number
        },
        offline: {
            total: number,
            percentage: number
        }
    },
    license: {
        name: string,
        icon: string
    },
    placeholder: {
        name: string,
        icon: string
    },
    time: string,
    legendTime: string,
    timeReference: string
}


type Dropdown = {
    label: string,
    value: string
}

type FilterOption = {
    title: string
    key: string
}

const typeIcon = (uplink: Uplink) => {
    switch (uplink?.icon.toUpperCase()) {
        case "SATCOM":
            return (<Satcom color={uplink?.color} background={uplink?.background} />)
        case "CELULAR1":
            return (<Celular1 color={uplink?.color} background={uplink?.background} />)
        case "CELULAR2":
            return (<Celular2 color={uplink?.color} background={uplink?.background} />)
        default:
            return (<div style={{fontSize: "24px", color: `${uplink?.color}`}}><i className={uplink?.icon}></i></div>)

    }
}

const UplinkIcon = (datas: []) => {
    return (<div style={{display: 'flex', gap: '8px'}}>
        {datas?.datas?.map(data => {
            return typeIcon(data)
        })}
    </div>)
}
export const StackStatus = () => {

    const [filterVehicle, setFilterVehicle] = useState<FilterOption[]>([]);
    const [initialFilterVehicle, setInitialFilterVehicle] = useState<FilterOption[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [vehicleSelectedValue, setVehicleSelectedValue] = useState<string[]>([])
    const [ eventHeader, setEventHeader ] = useState<Event>()
    const [ eventDropdown, setEventDropdown ] = useState<any>()
    const [ eventTable, setEventTable ] = useState<EventTable[]>()

    const [dataTable, setDataTable] = useState([])
    const [columns, setColumns] = useState([])

    const [statusPosition, setStatusPosition] = useState<number>(0)
    const [obcPosition, setOBCPosition] = useState<number>(0)
    const [customerPosition, setCustomerPosition] = useState<number>(0)
    const [quantityDataTable, setQuantityDataTable] = useState<number>(0)

    const [kpiInformation, setKpiInformation] = useState<PropsInformation>()

    // @ts-ignore
    const subscriptionHeader = new Subscriber({
        url: `/services/plugin-stacks-info/stack-status/header`
    })
    // @ts-ignore
    const subscriptionDropdown = new Subscriber({
        url: `/services/plugin-stacks-info/stack-status/dropdown-customer`
    })
    // @ts-ignore
    const subscriptionTable = new Subscriber({
        url: `/services/plugin-stacks-info/stack-status/table`
    })


    useEffect(() => {
        setIsLoading(true)
        subscriptionHeader.on('event', (events : any[]) => {
            setEventHeader(events[0])
        })
        subscriptionDropdown.on('event', (events : any[]) => {
            setEventDropdown(events[0])
        })
        subscriptionTable.on('event', (events : any[]) => {
            setEventTable(events)
        })

        subscriptionHeader.flush()
        subscriptionDropdown.flush()
        subscriptionTable.flush()
        setIsLoading(false)

    }, [])

    useEffect(() => {
        const options: FilterOption[] = Array.from(new Set(eventDropdown?.options?.reduce((acc, curr) => [...acc, { title: curr?.label, key: curr?.label }], [])))
        setFilterVehicle(options)

        console.log('opt: ', options)
        console.log('initial: ', initialFilterVehicle)
        console.log('vehicle: ', vehicleSelectedValue)

        if(
            vehicleSelectedValue.length <= 0 ||
            ((initialFilterVehicle !== options) && (vehicleSelectedValue.length === initialFilterVehicle.length))
        ) {
            console.log('entrou no if')
            setVehicleSelectedValue(options?.reduce((acc, curr) => [...acc, curr?.key], [])?.filter(item => item !== undefined))
        }

        console.log('init: ', initialFilterVehicle.length == 0)
        console.log('init: ', initialFilterVehicle != filterVehicle)

        if(initialFilterVehicle.length == 0 || initialFilterVehicle != filterVehicle) {
            console.log('entrou pra preencher o initial')
            setInitialFilterVehicle(options)
        }

    }, [eventDropdown]);

    useEffect(() => {
        console.log('updated: ', vehicleSelectedValue)
    }, [vehicleSelectedValue]);

    const handleSelectValue = (value) => {
        setVehicleSelectedValue(value)
    }

    const DefaultComponent = ({ data }) => <DivDefaultComponent>
        <LiveTooltip
            className="tooltipDefaultComponent"
            content={<span style={{color: 'var(--gray-0)', fontSize: '14px', display: 'flex', flexWrap: 'nowrap'}}>{data}</span>}
            position="left"
        >
            <span style={{color: 'var(--gray-800)', fontSize: '16px'}}>{data}</span>
        </LiveTooltip>


    </DivDefaultComponent>;
    const StackComponent = ({ data }) =>
        <div style={{display: "flex", width: '100%', height: '100%', justifyContent: "center", alignItems: 'center'}}>
            <div style={{fontFamily: 'SourceSansPro-Semibold', fontWeight: 600, background: `${data?.color}`, color: 'var(--gray-0)', width: '71px', height: '24px', borderRadius: '3px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '16px'}}> {data?.status}</div>
        </div>
    const ObcComponent = ({ data }) => <div style={{display: 'flex', alignItems: 'center', gap: '3.5px'}}> <div style={{background: `${data?.color}`, borderRadius: '50%', width: '12px', height: '12px'}}/> {data?.status}</div>
    const UplinksIconComponent = ({ data }) => <UplinkIcon datas={data} />
    const AvailabilityComponent = ({ data }) => <AvailabilityGraphDaily availabilitys={data} />;

    const componentMap = {
        availability: AvailabilityComponent,
        stack: StackComponent,
        obc: ObcComponent,
        uplinks: UplinksIconComponent
    };

    const CUSTOM_COLUMNS_TITLE = {
        "AVAILABILITY": 'NET. AVAIL. (LAST 30 DAYS)',
    }

    const generateColumns = (obj, componentMap) => {
        const columns = [];
        let index = 1;


        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if(key?.toUpperCase() === '__CUSTOMER') {
                    setCustomerPosition(index)
                }
                if (!key?.startsWith("__")) {
                    if (key?.toUpperCase() !== 'TIMESTAMP') {
                        const defaultTitle = key?.split("_").join(" ").toUpperCase()
                        const title = CUSTOM_COLUMNS_TITLE[defaultTitle] ?? defaultTitle;
                        let styledColumn: React.CSSProperties;


                        if (title === "STACK") {
                            setStatusPosition(index)
                            styledColumn = { textAlign: 'center', width: '120px', verticalAlign: 'middle'}
                        }
                        else if (title === "OBC") {
                            setOBCPosition(index)
                            styledColumn = { textAlign: 'start', width: '120px'}
                        } else if (title === "UPLINKS") {
                            styledColumn = { textAlign: 'center', width: '120px', verticalAlign: 'middle'}
                        } else if (title === "VEHICLE ID") {
                            styledColumn = {textAlign: 'start', maxWidth: '400px', width: '23%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
                        } else if (title === "NET. AVAIL. (LAST 30 DAYS)") {
                            styledColumn = {textAlign: 'start', maxWidth: '50%', width: '39%'}
                        } else {
                            styledColumn = {textAlign: 'start', width: '12%', minWidth: '12%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
                        }

                        columns.push({
                            column: index,
                            headerTitle: title,
                            component: componentMap[key] || DefaultComponent,
                            style: styledColumn
                        });
                        index++;
                    }
                }
            }
        }

        return columns;
    };

    const generateData = (events) => {
        return events?.map(event => {
            const data = {};
            let index = 1;

            for (const key in event) {
                if (key !== 'timestamp')
                    if (event.hasOwnProperty(key)) {

                        data[index] = event[key];

                        index++;
                    }
            }

            return data;
        });
    };

    useEffect(() => {
        setColumns(generateColumns(eventTable?.[0], componentMap))
        const dataTable = generateData(eventTable)
        setDataTable(dataTable)
    }, [eventTable]);

    function calculatePercentage(part: number, total: number): number {
        if(isNaN(part) || isNaN(total)) return 0;
        if (total === 0) {
            return 0;
        }
        return parseFloat(((part / total) * 100).toFixed(0));
    }

    useEffect(() => {
        let totalStacks = dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition])).length
        let stacksActive = dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[statusPosition]?.status.toUpperCase() === STATUS.ACTIVE.toUpperCase()).length
        let percentageStacksActive = calculatePercentage(dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[statusPosition]?.status.toUpperCase() === STATUS.ACTIVE.toUpperCase()).length, totalStacks)
        let stacksInactive = dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[statusPosition]?.status.toUpperCase() === STATUS.INACTIVE.toUpperCase()).length
        let percentageStacksInactive = calculatePercentage(dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[statusPosition]?.status.toUpperCase() === STATUS.INACTIVE.toUpperCase()).length, totalStacks)
        let obcOnline = dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[obcPosition]?.status.toUpperCase() === OBC.ONLINE.toUpperCase()).length
        let percentageObcOnline = calculatePercentage(dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[obcPosition]?.status.toUpperCase() === OBC.ONLINE.toUpperCase()).length, totalStacks)
        let obcOffline = dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[obcPosition]?.status.toUpperCase() === OBC.OFFLINE.toUpperCase()).length
        let percentageObcOffline = calculatePercentage(dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))?.filter(item => item[obcPosition]?.status.toUpperCase() === OBC.OFFLINE.toUpperCase()).length, totalStacks)
        setKpiInformation({
            totalStacks: totalStacks,
            stacksActive: stacksActive,
            percentageStacksActive: percentageStacksActive,
            stacksInactive: stacksInactive,
            percentageStacksInactive: percentageStacksInactive,
            obcOnline: obcOnline,
            percentageObcOnline: percentageObcOnline,
            obcOffline: obcOffline,
            percentageObcOffline: percentageObcOffline
        })
    }, [vehicleSelectedValue, dataTable]);

    if(isLoading) {
        return (<Container>CARREGANDO</Container>)
    }

    type PropsTitle = {
        icon: string,
        title: string,
        styledIcon: StyleSheet,
        styledTitle: StyleSheet
    }

    const Title = ({icon, title, styledIcon, styledTitle}: PropsTitle) => {
        return (
            <Header>
                <IconHeader style={styledIcon}>
                    <i className={icon}></i>
                </IconHeader>
                <DivData>
                    <Name style={styledTitle}>{title}</Name>
                    <SpanUpdate>
                        <i className={"far fa-history"} />
                        Updated every minute
                    </SpanUpdate>
                </DivData>
            </Header>
        )
    }

    return(<Container>
        <GlobalStyle />
        <RowToWidget style={{ justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Title
                    icon={eventHeader?.title?.icon}
                    styledIcon={{
                        backgroundColor: 'var(--blue-700)',
                        width: 40,
                        height: 40,
                        fontSize: 24,
                        color: 'white'
                    }}
                    title={eventHeader?.title?.name}
                    styledTitle={{ color: 'var(--gray-800)', fontSize: 24 }}
                />
                <Separator orientation="vertical" color="var(--gray-300)" />
                <HeaderItem
                    iconConfig={
                        {
                            size: 16,
                            icon: 'fas fa-building',
                            color: 'var(--blue-700)',
                            // width: 20,
                            // height: 20,
                            // marginRight: 0,
                            // background: '#fff',
                            style: {
                                border: 'none'
                            }
                        }
                    }
                >
                    <div style={{ display: 'flex', minWidth: 'fit-content', flexWrap: 'nowrap', alignItems: 'center' }} className="section-middle">
                        <Sanitizer html={'Customer:'}>
                            {sanitized => (
                                <span
                                    style={{ textTransform: 'uppercase', color: 'var(--gray-600)', fontFamily: 'SourceSansPro-Semibold', fontSize: '16px', fontWeight: 600 }}
                                    dangerouslySetInnerHTML={{
                                        __html: sanitized
                                    }}
                                />
                            )}
                        </Sanitizer>
                        {
                            filterVehicle &&
                            <Dropdown
                                apply={(keys) => handleSelectValue(keys)}
                                options={filterVehicle}
                                filterApplyed={vehicleSelectedValue}
                                warning={{
                                    title: i18n("No customer selected."),
                                    subtitle: i18n(
                                        "Please select at least one Customer to continue."
                                    ),
                                }}
                                isSmall={false}
                                topPosition={106}
                            />}
                    </div>
                </HeaderItem>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'flex', gap: '8px', fontWeight: 600, fontSize: '16px', alignItems: 'center', color: 'var(--gray-800)', fontFamily: 'SourceSansPro-Semibold' }}>
              <div style={{ width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                  <i className="far fa-clock" style={{ color: 'var(--blue-700)', fontWeight: 400, fontSize: 19 }} />
              </div>

              {eventHeader?.time} {eventHeader?.legendTime}
          </span>
                <Separator orientation="vertical" color="var(--gray-300)" />
                <span style={{ display: 'flex', gap: '4px', fontWeight: 400, fontSize: 16, alignItems: 'center', fontFamily: 'SourceSansPro-Regular', color: 'var(--gray-800)' }}>
            {eventHeader?.timeReference}
          </span>

            </div>
            {/*<button onClick={()=>setVehicleSelectedValue(null)}>clean</button>*/}
        </RowToWidget>

        <RowToWidget>
            <KpiInformation
                totalStacks={kpiInformation?.totalStacks}
                stacksActive={kpiInformation?.stacksActive}
                percentageStacksActive={kpiInformation?.percentageStacksActive}
                stacksInactive={kpiInformation?.stacksInactive}
                percentageStacksInactive={kpiInformation?.percentageStacksInactive}
                obcOnline={kpiInformation?.obcOnline}
                percentageObcOnline={kpiInformation?.percentageObcOnline}
                obcOffline={kpiInformation?.obcOffline}
                percentageObcOffline={kpiInformation?.percentageObcOffline}
            />

        </RowToWidget>

        <RowToWidget style={{height: '100%'}}>
            <DynamicTable
                columns={columns}
                data={dataTable?.filter(item => vehicleSelectedValue.includes(item[customerPosition]))}
                styledTable={{
                    border: '1px solid var(--gray-300)',
                    borderCollapse: 'separate',
                    borderSpacing: '0',
                    borderRadius: '3px'
                }}
                styledHeader={{ background: 'var(--gray-100)', color: 'var(--gray-700)', fontSize: '16px', borderRadius: '3px 3px 0 0' }}

                styledColumnHeader={{borderBottom: 'none', padding: '8px 16px', color: 'var(--gray-700)', fontSize: '16px'}}
                styledColumnBody={{borderBottom: 'none', padding: '8px 16px'}}
                footer={true}
                footerType={'stacks'}
                styledFooter={{ background: 'var(--gray-100)', height: '26px', borderRadius: '0 0 3px 3px', padding: '4px 16px', borderTop: '1px solid var(--gray-300)' }}
            />
        </RowToWidget>
    </Container>)

}

const DivDefaultComponent = styled.div`
    overflow: hidden;
    text-overflow: ellipsis; 
    white-space: nowrap;
  

    .tooltipDefaultComponent {
      display: flex;
      flex-wrap: nowrap;
      width: fit-content;
      background: red;
    }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 24px 24px 24px;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  gap: 24px;
  z-index: 9;
  position: relative;
  top: 0;
`

const Name = styled.div`
    color: var(--gray-800);
    font-size: 20px;
    font-weight: 600;
    text-transform: none;
    display: block;
  line-height: 120% !important;
`

const DivData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 120% !important;
`

const Header = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    gap: 8px;
    align-items: center;
    text-transform: none;
    font-family: 'SourceSansPro-SemiBold', sans-serif;
`

const SpanUpdate = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme['gray-600']};
  font-family: 'SourceSansPro-Regular', sans-serif;
  display: flex;
  align-items: center;
  gap: 2px;
  line-height: 120% !important;
  
  i {
    padding: 4px;
  }
`

const IconHeader = styled.div`
    background-color: ${({ theme }) => theme['gray-200']};
    width: 34px;
    height: 34px;
    padding: 2px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    font-size: 22px;
    color: ${({ theme }) => theme['gray-700']};
`